 export enum NeoresCodeEffectif {
M01 = 0,
M02 = 1,
M03 = 2,
M04 = 3,
M05 = 4,
A01 = 5,
A02 = 6,
A03 = 7,
A04 = 8,
A05 = 9,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/NeoresCodeEffectif.ts